<!-- @format -->

@if (isRibbonGAMBannerEnabled()) {
	<div class="hmf-my-xs">
		<!-- ATF GAM component instances should not be deferred -->
		<shared-components-google-ad-manager
			[data]="'top_ribbon_banner'"
			[showSponsoredLabel]="true"
			[enableTooltipSurvey]="enableTooltipSurvey()"
			[hasTopMargin]="false"
			[enableAdCarousel]="true"
			[isNarrowBanner]="false">
		</shared-components-google-ad-manager>
	</div>
}

<div class="hmf-mt-xxs hmf-mt-md-s hmf-mb-l hmf-px-s hmf-display-flex product-details-container">
	<!-- image carousel will go here -->
	<div class="hmf-display-flex hmf-flex-column">
		<h1 class="hmf-body-bold-m hmf-header-bold-md-s hmf-header-bold-lg-m hmf-header-bold-xlg-l hmf-mb-xxxs hmf-mb-md-xxs" itemprop="name">
			{{ product()?.name }}
		</h1>
		@if (promotions()) {
			<pdp-promotion [promotions]="promotions()" [addFlexBox]="true" textContainerClasses="hmf-mb-xxxs hmf-mb-md-xxs" [linkHref]="basePDPUrl">
			</pdp-promotion>
		}
		@if (!reviewsOff()) {
			<a class="hmf-mb-xxxs hmf-mb-md-xs hmf-mb-lg-s" [href]="basePDPUrl">
				<product-reviews-rating-summary-stars-v2
					[productPartNumber]="product()?.partNumber"
				></product-reviews-rating-summary-stars-v2>
			</a>
		}
		<pdp-price
			class="hmf-mb-xxs hmf-mb-md-xs hmf-mb-lg-s"
			[ecodePriceData]="product().prices"
			[staticSkuPriceData]="resolvedSku?.prices"
			[isHybridPLA]="true"
		></pdp-price>
		@if (product().skus.length > 1) {
			<pdp-hybrid-pla-attribute-thumbnails
				class="hmf-mb-m hmf-mb-lg-l"
				[product]="product()"
				[basePDPUrl]="basePDPUrl"
			></pdp-hybrid-pla-attribute-thumbnails>
		}
		<!-- atc buttons -->
		@if (product().buyable) {
			<pdp-bnpl class="hmf-mt-s" [productPrice]="product().prices"
					  [isProductPaypalEligible]="product().isPayPalEligible">
			</pdp-bnpl>
		}
	</div>
</div>
